module.exports = __webpack_public_path__ + "img/zhongugancun.f20fa1c4.png";